export default __webpack_public_path__ + "static/media/artesania diria.e1d30ad1.jpg";